import type { CanDeactivateFn } from '@angular/router';

/** Route-leave guard for the journey editor: confirm before dropping an unsaved journey. */
export const journeyTemplatesUnsavedGuard: CanDeactivateFn<{ hasUnsavedChanges(): boolean }> = (component) => {
    if (!component?.hasUnsavedChanges?.()) return true;
    return window.confirm('You have unsaved changes to this journey. Leave and discard them?');
};
